export const EVENT_SPECIALIZATIONS = [
  "Catering Staff", "Catering Captain", "Security", "Cameraman", "Helpers", "Event Crew",
  "Bartender", "Decorator", "Sound Engineer", "Usher",
];

export const FREELANCE_SPECIALIZATIONS = [
  "Note Writing", "Poster Designing", "Graphic Designing", "Video Editing",
  "Photo Editing", "Content Writing", "Resume Designing", "Website Development",
  "Assignment Help", "Social Media Management",
];

export const ALL_SPECIALIZATIONS = [...EVENT_SPECIALIZATIONS, ...FREELANCE_SPECIALIZATIONS];
